export default {
    title: 'SMS',
    appointmentMessageLabel: 'Appointment Reminder Message',
    unsubscribeMessageLabel: 'Unsubscribe Message',
    unsubscribeInfo: 'Unsubscribe message is sent with automated message and SMS campaigns.',
    appendConfirmation: 'Append confirmation message to this message',
    enableForLabel: 'Enable appointment confirmation for all new appointment bookings:',
    enableForSales: 'For Sales leads',
    enableForService: 'For Service leads',
    customizeMessages: 'Customize Messages',
    disableOptOutMessage: 'Disable unsubscribe message for automated SMS',
    leaveEmptyForDefault: 'Leave empty to use default message',
    confirmationWillBeAppended: 'The following confirmation message will be appended',
};
